module.exports = __webpack_public_path__ + "mainassets/img/color-rectangle.c240f53e.svg";